import { useState } from 'react'
import styles from './Options.module.scss'
import { OptionsProps, ToolTipContentProps } from './types.ts'
import { CellVariant } from '../cell/types.ts'
import Cell from '../cell/Cell.tsx'
import { useTranslation } from 'react-i18next'
import Link from 'components/link/Link.tsx'
import { Icon, Tooltip } from '@boltenergy-be/design-system'
import { isCustomerInvoice, isCustomerPayment } from 'pages/app/billing/invoices/utils.ts'

const ToolTipContent = ({ document }: ToolTipContentProps) => {
  return (
    <>
      {isCustomerInvoice(document) && !!document?.pdfUrl && (
        <Link
          href={document.pdfUrl}
          as="a"
          representation="button"
          variant="tertiary"
          download
          isFullwidth
          target="_blank"
          trailingIcon="download"
          size="small"
        >
          {document.invoiceNumber}
        </Link>
      )}

      {isCustomerPayment(document) && !!document?.paymentReference && (
        <strong className={styles['non-break']}>{document.paymentReference}</strong>
      )}
    </>
  )
}

const Options = ({ document }: OptionsProps) => {
  // i18n
  const { t } = useTranslation('invoices')

  // Local state
  const [open, setOpen] = useState(false)

  return (
    <Cell variant={CellVariant.OPTIONS} title={t(($) => $.cells.moreOptions)}>
      <Tooltip
        tooltipContent={<ToolTipContent document={document} />}
        tooltipContentClassName={styles.tooltip}
        placement="bottom-start"
        open={open}
        onOpenChange={setOpen}
        asChild
      >
        <button type="button" className={styles.trigger} onClick={() => setOpen(true)}>
          <Icon name="ellipsisH" />
        </button>
      </Tooltip>
    </Cell>
  )
}

export default Options
